import { render } from "./ChangePasswordForm.vue?vue&type=template&id=ea43da8e&scoped=true&bindings={\"wasValidated\":\"data\",\"currentPassword\":\"data\",\"newPassword\":\"data\",\"newPasswordAgain\":\"data\",\"passwordMinLength\":\"options\",\"newPasswordsMatch\":\"options\",\"postChangePassword\":\"options\"}"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=ea43da8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ea43da8e"

export default script